module.exports = __webpack_public_path__ + "static/media/driver-promo-page-bg-mobile.87d6b22e.png";